var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (window.LBF_CART) window.LBF_CART.setAdding(this.submitButton, true);
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (window.LBF_CART && window.LBF_CART.confirmAdded) {
              const confirmation = window.LBF_CART.confirmAdded('', this.submitButton);
              if (quickAddModal) quickAddModal.hide(true);
              return confirmation;
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(lbnT('product.add_unconfirmed', 'We could not confirm the add. Please check your cart before adding again.'));
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (window.LBF_CART) window.LBF_CART.setAdding(this.submitButton, false);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          // FIX 2026-06-10: scope to <product-info> first. In the quick-add
          // modal the product is injected WITHOUT its <section> wrapper, so
          // closest('section') returned null (or matched the collection
          // section), wiping the "• price" from the button on variant change.
          const productScope = this.closest('product-info') || this.closest('section');

          const priceEl = productScope?.querySelector('.price-item--sale, .price-item--regular');

          const variantInput = this.form.querySelector('.product-variant-id');

          if (priceEl && variantInput) {
            const priceText = priceEl.textContent.trim().replace(/\s+/g, ' ');

            const numericPrice = parseFloat(priceText.replace(/[^\d.]/g, ''));

            if (!isNaN(numericPrice) && numericPrice > 0) {
              variantInput.dataset.price = Math.round(numericPrice * 100);
            }

            this.submitButtonText.innerHTML = `
              ${window.variantStrings.addToCart} •
              <span class="add-to-cart-price">${priceText}</span>
            `;
          } else if (!this.submitButton.querySelector('.add-to-cart-price')) {
            // Only fall back to plain text if there is no price span to
            // preserve — never destroy an existing "• price".
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {

  function formatMoney(value) {
    return `RM${value.toFixed(2)}`;
  }

  function isBundlePage() {
    return window.location.pathname.includes('build-your-travel-box');
  }

  function getBundlePrice() {
    const allEls = document.querySelectorAll('div, span, p');

    for (const el of allEls) {
      const text = el.textContent.trim();

      if (text === 'Total') {
        const parent = el.parentElement;
        if (!parent) continue;

        const match = parent.textContent.match(/RM[\d,.]+/);
        if (match) {
          return match[0];
        }
      }
    }

    return null;
  }

  // FIX 2026-06-10: every lookup is scoped to the same <product-info> as the
  // button being updated. Previously document-wide querySelector grabbed the
  // FIRST .product-variant-id on the page — on collection pages that is a
  // single-variant quick-buy card input with NO data-price, so the quick-add
  // modal button showed "RM0.00" after selecting an option or changing qty.
  function getNormalProductPrice(priceSpan) {
    const scope = priceSpan.closest('product-info');
    if (!scope) return null;

    const variantInput = scope.querySelector('.product-variant-id');
    if (!variantInput) return null;

    const unitPrice = parseFloat(variantInput.dataset.price);

    // Never render RM0.00 — keep the server-rendered price instead.
    if (isNaN(unitPrice) || unitPrice <= 0) return null;

    const mainQtyInput = scope.querySelector('.quantity__input');

    // Sticky ATC exists only on product pages — never pair it with a
    // quick-add modal button.
    const inQuickAdd = !!priceSpan.closest('quick-add-modal');
    const stickyQtyInput = inQuickAdd ? null : document.querySelector('#sticky-add-to-cart-quantity');
    const stickyWrapper = inQuickAdd ? null : document.querySelector('#bundle-sticky_add_to_cart');

    // use sticky qty when sticky visible
    const useStickyQty = stickyWrapper && stickyWrapper.offsetParent !== null && stickyQtyInput;

    const activeQtyInput = useStickyQty ? stickyQtyInput : mainQtyInput;

    const qty = parseInt(activeQtyInput && activeQtyInput.value) || 1;

    const total = (unitPrice * qty) / 100;

    // sync main qty
    if (useStickyQty && mainQtyInput && parseInt(mainQtyInput.value) !== qty) {
      mainQtyInput.value = qty;
    }

    return formatMoney(total);
  }

  function getFinalPrice(priceSpan) {
    if (isBundlePage() && !priceSpan.closest('quick-add-modal')) {
      return getBundlePrice();
    }

    return getNormalProductPrice(priceSpan);
  }

  function updateMainATC() {
    // Update every ATC price span (main product page button AND any open
    // quick-add modal button), each against its own product scope.
    document.querySelectorAll('.product-form__submit .add-to-cart-price').forEach((priceSpan) => {
      const price = getFinalPrice(priceSpan);
      if (!price) return;
      priceSpan.textContent = price;
    });
  }

  function updateStickyATC(retries = 10) {
    const stickyButton = document.querySelector('#bundle-sticky_submit');

    if (!stickyButton) {
      if (retries > 0) {
        setTimeout(() => {
          updateStickyATC(retries - 1);
        }, 500);
      }
      return;
    }

    // COPY FROM MAIN BUTTON — never from a quick-add modal button
    const mainButtonPrice = Array.from(
      document.querySelectorAll('.product-form__submit .add-to-cart-price')
    ).find((el) => !el.closest('quick-add-modal'));

    if (!mainButtonPrice) return;

    const price = mainButtonPrice.textContent.trim();

    stickyButton.textContent = lbnT('product.sticky_add_to_cart_price', 'Add to cart • {{ price }}', { price: price });
  }

  function syncAllButtons() {
    updateMainATC();
    updateStickyATC();
  }

  // MAIN QTY INPUT
  document.addEventListener('input', function (e) {
    if (e.target.matches('.quantity__input')) {
      syncAllButtons();
    }
  });

  // STICKY QTY INPUT
  document.addEventListener('input', function (e) {
    if (e.target.matches('#sticky-add-to-cart-quantity')) {
      syncAllButtons();
    }
  });

  // PLUS MINUS BUTTONS
  document.addEventListener('click', function (e) {
    // Dawn qty buttons
    if (e.target.closest('.quantity__button')) {
      setTimeout(syncAllButtons, 50);
      setTimeout(syncAllButtons, 150);
    }

    // Sticky app qty buttons
    if (e.target.closest('#bundle-sticky_add_to_cart')) {
      setTimeout(syncAllButtons, 50);
      setTimeout(syncAllButtons, 150);
      setTimeout(syncAllButtons, 300);
      setTimeout(syncAllButtons, 500);
    }
  });

  // VARIANT CHANGES
  document.addEventListener('change', function () {
    setTimeout(syncAllButtons, 120);
    // Re-sync after Dawn's section re-render completes in the quick-add modal
    setTimeout(syncAllButtons, 600);
  });

  // BUNDLE PAGE AUTO REFRESH
  if (isBundlePage()) {
    setInterval(syncAllButtons, 1000);
  }

  // INITIAL LOAD
  syncAllButtons();

});
